var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "#D8E6FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6667 53.3337H37.3334C32.305 53.3337 29.7909 53.3337 28.2288 51.7716C26.6667 50.2095 26.6667 47.6953 26.6667 42.667V37.3337C26.6667 32.3053 26.6667 29.7912 28.2288 28.2291C29.7909 26.667 32.3183 26.667 37.3731 26.667C38.1811 26.667 38.8286 26.667 39.3734 26.6892C39.3554 26.7958 39.346 26.9045 39.3457 27.0144L39.3333 30.7936C39.3332 32.2564 39.3331 33.5492 39.4732 34.5912C39.6251 35.7207 39.9738 36.85 40.8955 37.7717C41.8171 38.6934 42.9465 39.0421 44.076 39.1939C45.118 39.334 46.4107 39.3339 47.8736 39.3338L48 39.3338H53.2766C53.3334 40.0462 53.3334 40.9205 53.3334 42.0842V42.667C53.3334 47.6953 53.3334 50.2095 51.7713 51.7716C50.2092 53.3337 47.695 53.3337 42.6667 53.3337ZM37.9977 43.2529C38.4105 43.6198 38.4477 44.2519 38.0808 44.6647L34.5252 48.6647C34.3354 48.8782 34.0634 49.0003 33.7778 49.0003C33.4922 49.0003 33.2202 48.8782 33.0304 48.6647L31.2526 46.6647C30.8857 46.2519 30.9229 45.6198 31.3357 45.2529C31.7484 44.886 32.3805 44.9232 32.7474 45.336L33.7778 46.4951L36.5859 43.336C36.9529 42.9232 37.5849 42.886 37.9977 43.2529Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5239 29.4053L49.8023 34.1559C51.4245 35.6158 52.2901 36.3948 52.7735 37.3338H48C44.8573 37.3338 43.286 37.3338 42.3097 36.3575C41.3334 35.3812 41.3334 33.8098 41.3334 30.6671L41.3457 27.0212C42.2682 27.3752 43.0201 28.0519 44.5239 29.4053Z",
    fill: "#3B82F6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Avatar.672cd30710a93947eef846339c268d00.svg";